import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
// import { map } from 'rxjs/operators';
import { AskEstimate } from '../models/smsadv/estimate';
import { BehaviorSubject, Observable } from 'rxjs';
import { RecipientCriteria, SmsAdv } from '@models/smsadv/smsadv';
import { compare } from 'fast-json-patch';

export enum ActionSmsAdv {
  ACTION_EDIT,
  ACTION_COPY,
  ACTION_SEND
}
@Injectable({
  providedIn: 'root'
})
export class SmsAdvService {
  private readonly baseUrl;

  private actionSmsAdv = new BehaviorSubject<any>(false);

  get actionSmsAdv$(): Observable<any> {
    return this.actionSmsAdv.asObservable();
  }

  setActionSmsAdv(value) {
    if (value) {
      this.actionSmsAdv.next(value);
    }
  }

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getCountByZipCode(data) {
    return this.http.post<Response>(this.baseUrl + 'smsadv/wellpack/query', { jsonQuery: data });
  }

  askEstimate(data: AskEstimate) {
    return this.http.post<Response>(this.baseUrl + 'smsadv/send-mail-resume', data);
  }

  /**
   * Retrieve a Sms Adv Campaign from id
   */
  getSmsAdvCampaign(idSmsAdvCampaign): Observable<SmsAdv> {
    const header = { 'Content-Type': 'application/json' };
    return this.http.get<SmsAdv>(this.baseUrl + 'smsadv/' + idSmsAdvCampaign, { headers: header });
  }

  /**
   * Delete a Sms Adv Campaign from id
   */
  deleteSmsAdvCampaign(idSmsAdvCampaign) {
    return this.http.delete(this.baseUrl + '/smsadv/' + idSmsAdvCampaign);
  }

  /**
   * Create a new SmsAdv Campaign
   */
  createSmsAdvCampaign(requestBody): Observable<any> {
    const suffixUrl = 'smsadv';
    const url = this.baseUrl + suffixUrl;
    return this.http.post(url, requestBody);
  }

  searchCriteria(): Observable<RecipientCriteria> {
    const suffixUrl = 'smsadv/ediscom/list-criteria';
    const url = this.baseUrl + suffixUrl;
    return this.http.get<RecipientCriteria>(url);
  }

  countRecipients(requestBody: RecipientCriteria): Observable<any> {
    const suffixUrl = 'smsadv/ediscom/count-recipients';
    const url = this.baseUrl + suffixUrl;
    return this.http.post(url, requestBody);
  }

  /**
   * Update SmsAdv Campaign
   */

  updateSmsAdvCampaign(idSmsAdvCampaign, smsAdvOld: SmsAdv, smsAdvNew: SmsAdv): Observable<any> {
    const patchHeaders = new HttpHeaders().set('Content-type', 'application/json-patch+json');
    const patchData = compare(smsAdvOld, smsAdvNew);
    const url = 'smsadv/' + idSmsAdvCampaign;
    return this.http.patch<Response>(this.baseUrl + url, patchData, { headers: patchHeaders });
  }

  /**
   * Copy SmsAdv Campaign
   */

  copySmsAdvCampaign(idSmsAdvCampaign): Observable<any> {
    const url = 'smsadv/campaigns/' + idSmsAdvCampaign + '/copy';
    return this.http.post(this.baseUrl + url, {});
  }

  /**
   * Send Sms Adv
   */

  sendSmsAdvCampaign(idSmsAdvCampaign): Observable<any> {
    const url = 'smsadv/' + idSmsAdvCampaign + '/send-campaign';
    return this.http.post(this.baseUrl + url, {});
  }
}
